var module = angular.module('octopusApp.users');

module.controller('AuthProviderController', function ($scope) {

    $scope.name = $scope.provider.Name;

    $scope.linkHtml = $scope.provider.LinkHtml;
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/users/controllers/auth_provider_controller.js
// module id = 640
// module chunks = 1